export default "__VITE_ASSET__8220c39d__"